import { render, staticRenderFns } from "./ModalAdicionarOuEditarContaBloqueada.vue?vue&type=template&id=390ce88a&scoped=true"
import script from "./ModalAdicionarOuEditarContaBloqueada.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarOuEditarContaBloqueada.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarOuEditarContaBloqueada.vue?vue&type=style&index=0&id=390ce88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ce88a",
  null
  
)

export default component.exports